export default __webpack_public_path__ + "static/media/image04.096e0f0d.png";